import React from 'react';
import FigmaBadge from '../Elements/FigmaBadge';
import RedirectLinkComponent from '../Elements/RedirectLinkComponent';
import dateTimeHelper from '../Helpers/datetimeHelper';
import stringHelper from '../Helpers/stringHelper';

export default class ExcludedAssignmentItem {
  constructor(item) {
    if (item === undefined) {
      this.AsId = '';
      this.AsSassieAsgnId = '';
      this.CuName = '';
      this.AsFee = '';
      this.OpportunityCurrencySymbol = '';
      this.AsFeeAddit = '';
      this.AsReimbursement = '';
      this.ReimbursementCurrencySymbol = '';
      this.AsTravel = '';
      this.AsGaming = '';
      this.AsMisc = '';
      this.AsLdvname = '';
      this.AsFieldworkFee = '';
      this.AsEvname = '';
      this.LgsDesc = '';
      this.AsEvaluatorCompletedDate = '';
      this.CuCountry = '';
      this.AsEvaluatorCompletedDateFormatted = '';
      this.AsUninvoiceable = '';
      this.EvaluatorCurrencySymbol = '';
      this.ReimbursementCurrencySymbol = '';
      this.AsIeFee = '';
      this.AsIeFeeAdjustment = '';
      this.AsIeReimbursement = '';
      this.AsIeTravel = '';
      this.AsIeGaming = '';
      this.AsIeMisc = '';
      this.InFieldworkFee = '';
      this.AsIeFeeWithSymbol = '';
      this.AsIeFeeAdjustmentWithSymbol = '';
      this.AsIeReimbursementWithSymbol = '';
      this.AsIeTravelWithSymbol = '';
      this.AsIeGamingWithSymbol = '';
      this.AsIeMiscWithSymbol = '';
      this.InFieldworkFeeWithSymbol = '';
      this.ClientName = '';
      this.AsCfname = '';
      this.AsCfid = '';
      this.FeeTotal = '';
      this.ReimbTotal = '';
      this.Selected = false;
      this.ProjectIdAndName = '';
      return;
    }
    this.AsId = item.asId;
    this.AsSassieAsgnId = item.asSassieAsgnId;
    this.CuName = item.cuName;
    this.AsFee = item.asFee;
    this.OpportunityCurrencySymbol = item.opportunityCurrencySymbol;
    this.AsFeeAddit = item.asFeeAddit;
    this.AsReimbursement = item.asReimbursement;
    this.ReimbursementCurrencySymbol = item.reimbursementCurrencySymbol;
    this.AsTravel = item.asTravel;
    this.AsGaming = item.asGaming;
    this.AsMisc = item.asMisc;
    this.AsLdvname = item.asLdvname;
    this.AsFieldworkFee = item.asFieldworkFee;
    this.AsEvname = item.asEvname;
    this.LgsDesc = item.lgsDesc;
    this.AsEvaluatorCompletedDate = item.asEvaluatorCompletedDate;
    this.CuCountry = item.cuCountry;
    this.AsEvaluatorCompletedDateFormatted = dateTimeHelper.toYYYYsMMsDD(item.asEvaluatorCompletedDate, '-');
    this.AsUninvoiceable = item.asUninvoiceable ? 'True' : 'False';
    this.ReimbursementCurrencySymbol = item.reimbursementCurrencySymbol;
    this.EvaluatorCurrencySymbol = item.evaluatorCurrencySymbol;
    this.AsIeFee = item.asIeFee;
    this.AsIeFeeAdjustment = item.asIeFeeAdjustment;
    this.AsIeReimbursement = item.asIeReimbursement;
    this.AsIeTravel = item.asIeTravel;
    this.AsIeGaming = item.asIeGaming;
    this.AsIeMisc = item.asIeMisc;
    this.InFieldworkFee = item.inFieldworkFee;
    this.AsIeFeeWithSymbol = stringHelper.getValueWithSymbol('', item.evaluatorCurrencySymbol, item.asIeFee);
    this.AsIeFeeAdjustmentWithSymbol = stringHelper.getValueWithSymbol(
      '',
      item.evaluatorCurrencySymbol,
      item.asIeFeeAdjustment
    );
    this.AsIeReimbursementWithSymbol = stringHelper.getValueWithSymbol(
      '',
      item.reimbursementCurrencySymbol,
      item.asIeReimbursement
    );
    this.AsIeTravelWithSymbol = stringHelper.getValueWithSymbol('', item.reimbursementCurrencySymbol, item.asIeTravel);
    this.AsIeGamingWithSymbol = stringHelper.getValueWithSymbol('', item.reimbursementCurrencySymbol, item.asIeGaming);
    this.AsIeMiscWithSymbol = stringHelper.getValueWithSymbol('', item.reimbursementCurrencySymbol, item.asIeMisc);
    this.InFieldworkFeeWithSymbol = stringHelper.getValueWithSymbol(
      '',
      item.evaluatorCurrencySymbol,
      item.asFieldworkFee
    );
    this.ClientName = item.clientName == null ? '' : item.clientName;
    this.AsCfname = item.asCfname == null ? '' : item.asCfname;
    this.AsCfid = item.asCfid == null ? '' : item.asCfid;
    this.FeeTotal = stringHelper.getFeeTotal(item.evaluatorCurrencySymbol, [item.asIeFee, item.asIeFeeAdjustment]);
    this.ReimbTotal = stringHelper.getFeeTotal(item.reimbursementCurrencySymbol, [
      item.asIeReimbursement,
      item.asIeTravel,
      item.asIeGaming,
      item.asIeMisc,
    ]);
    this.Selected = false;
    this.ProjectIdAndName = this.AsCfid === '' ? '' : `${this.AsCfid} - ${this.AsCfname}`;
  }

  static NameOfTheIdField() {
    return 'AsId';
  }
  static nameOfTheItemDetailList() {
    return 'Ready for Invoicing';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = [];

  static BoolFields = [];

  static FieldsToShowInListTable = [];

  static idFunction(item) {
    return (
      <RedirectLinkComponent
        isFigmaStyle={true}
        path='assignments'
        tooltipText={item.AsSassieAsgnId}
        text={item.AsSassieAsgnId}
        keyValuePairs={[
          { key: 'AsBillClient', value: '' },
          { key: 'AsPayEvaluator', value: '' },
          { key: 'AsSassieAsgnId', value: item.AsSassieAsgnId },
        ]}
      />
    );
  }

  static getIsActiveCellContent(item) {
    return (
      <div className='pointer'>
        <FigmaBadge
          Active={item}
          ActiveText='Yes'
          InactiveText='No'
          width={50}
        />
      </div>
    );
  }
  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  static FieldsToShowInDataTable() {
    return [
      {
        label: ExcludedAssignmentItem.getSelectedCellHeader,
        orderById: '',
        data: ExcludedAssignmentItem.getSelectedCellContent,
        minWidth: 20,
        rolekey: 'project_excludedassignmentselect',
      },
      { label: 'Apollo Id', orderById: 'AsSassieAsgnId', data: ExcludedAssignmentItem.idFunction },
      { label: 'Location', orderById: 'CuName', data: 'CuName', minWidth: 250 },
      { label: 'Eval Fee Total', orderById: 'AsIeFeeWithSymbol', data: 'AsIeFeeWithSymbol', minWidth: 80 },
      {
        label: 'Eval Reimb. Total',
        orderById: 'AsIeReimbursementWithSymbol',
        data: 'AsIeReimbursementWithSymbol',
        minWidth: 80,
      },
      { label: 'FW Office', orderById: 'AsLdvname', data: 'AsLdvname' },
      { label: 'FW Fee', orderById: 'InFieldworkFeeWithSymbol', data: 'InFieldworkFeeWithSymbol', minWidth: 80 },
      { label: 'Evaluator', orderById: 'AsEvname', data: 'AsEvname' },
      { label: 'Status', orderById: 'LgsDesc', data: 'LgsDesc', minWidth: 70 },
      {
        label: 'Completed On',
        orderById: 'AsEvaluatorCompletedDateFormatted',
        data: 'AsEvaluatorCompletedDateFormatted',
        minWidth: 90,
      },
      { label: 'Country', orderById: 'CuCountry', data: 'CuCountry', minWidth: 55 },
      {
        label: 'Uninv.',
        orderById: 'AsUninvoiceable',
        data: (item) => ExcludedAssignmentItem.getIsActiveCellContent(item.AsUninvoiceable),
        minWidth: 55,
      },
    ];
  }

  static selectedStatus() {
    return false;
  }

  static getSelectedCellHeader(item) {
    return (
      <div>
        <input
          type='checkbox'
          checked={ExcludedAssignmentItem.selectedStatus()}
          onChange={(e) => {
            ExcludedAssignmentItem.clickOnGlobalSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static clickOnGlobalSelect(item, selected) {}

  static clickOnSelect(item, selected) {}

  static getSelectedCellContent(item) {
    return (
      <div className='text-center'>
        <input
          type='checkbox'
          checked={item.Selected}
          onChange={(e) => {
            ExcludedAssignmentItem.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  // static getActionsContent(item)
  // {
  // 	return (
  // 		<div>
  // 			<FaIcon
  // 				iconName="fa-solid fa-edit"
  // 				className="pointer link"
  // 				tooltipText="Edit"
  // 				onClick={()=>CaspianXXQueryProcessingHistoryItem.editFunction(item.Id,item)}
  // 			/>
  // 		</div>
  // 	);
  // }

  static editFunction(id, item) {
    //this is just a placeholder
  }
}
